import RemoveAttachmentModal from 'modals/RemoveAttachmentModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import styled from 'styled-components'
import { borderColor, primaryColor } from 'styles/styleVariables'
import type { AttachmentsOptions } from 'types'

const RemoveAttachment = ({ prescriptionId }: AttachmentsOptions): JSX.Element => {
  const { showModal } = useModalContext()

  const onRemoveAttachmentClicked = () => {
    showModal(() => <RemoveAttachmentModal prescriptionId={prescriptionId} />)
  }

  return <StyledButton onClick={onRemoveAttachmentClicked}>- Remove attachment</StyledButton>
}

const StyledButton = styled.div`
  height: 40px;
  margin-top: 15px;
  padding-left: 10px;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  border: 0.125rem solid ${borderColor};
  border-radius: 0.25rem;
  &:hover {
    border: 0.125rem solid ${primaryColor};
  }
`

export default RemoveAttachment
